'use client';
// apps/admin/src/app/global-error.tsx — ловит ошибки в root layout
import { useEffect } from 'react';
import { reportClientError } from '@tb/ui';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError({
      service: 'admin',
      severity: 'fatal',
      name: error.name || 'GlobalError',
      message: error.message || error.toString(),
      stack: error.stack,
      context: { source: 'global_error_boundary', digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="ru">
      <body>
        <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' }}>
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem' }}>
              Критическая ошибка
            </h2>
            <p style={{ color: '#666', marginBottom: '1rem', fontSize: '0.875rem' }}>
              Ошибка отправлена разработчикам.
            </p>
            <button
              onClick={reset}
              style={{
                background: '#2563eb', color: 'white', border: 'none',
                borderRadius: '0.5rem', padding: '0.5rem 1rem',
                fontSize: '0.875rem', cursor: 'pointer',
              }}
            >
              Повторить
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
